import { atom } from 'jotai';

export const reAgreeAtom = atom(false);
